import { render, staticRenderFns } from "./ResumenAsignacionPaquete.vue?vue&type=template&id=7730f94e&scoped=true"
import script from "./ResumenAsignacionPaquete.vue?vue&type=script&lang=js"
export * from "./ResumenAsignacionPaquete.vue?vue&type=script&lang=js"
import style0 from "./ResumenAsignacionPaquete.vue?vue&type=style&index=0&id=7730f94e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7730f94e",
  null
  
)

export default component.exports